import { Component, OnInit } from "@angular/core";
import { DashboardService } from "src/app/services/dashboard.service";
import { MonitoringStatus } from "src/app/shared/models/MonitoringStatusResponse";

@Component({
	selector: "app-widget-container",
	templateUrl: "./widget-container.component.html",
	styleUrls: ["./widget-container.component.scss"],
})
export class WidgetContainerComponent implements OnInit {
	constructor(private dashboardService: DashboardService) {}

	ngOnInit(): void {
		this.getServicesStatus();
	}

	getServicesStatus() {
		// this.dashboardService.monitoringServicesStatuses().subscribe(
		//    (result) => {
		//       let services = result.data as MonitoringStatus;
		//    },
		//    (error) => {
		//    }
		// );
	}
}
